import { Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import assambleaLogo from 'assets/images/Asamblea-logo.png';

export const Law = () => {
  return (
    <>
      <div style={{ paddingRight: 70, paddingLeft: 70, paddingTop: 20 }}>
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={2}>
            <Stack justifyContent={'center'}>
              <img src={assambleaLogo} alt="Asamblea Legislativa" />
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <br />
            <Typography align="center" variant="h2" component="h3">
              LA ASAMBLEA LEGISLATIVA
            </Typography>
            <Typography align="center"> LA ASAMBLEA LEGISLATIVA </Typography>
          </Grid>
        </Grid>
        <br />
        <br />
        <Typography variant="2">
          <strong>DECRETO N. ° 840</strong>
        </Typography>
        <Typography>
          <strong>LA ASAMBLEA LEGISLATIVA DE LA REPÚBLICA DE EL SALVADOR</strong>
        </Typography>
        <br />
        <Typography variant="2">
          <strong> CONSIDERANDO:</strong>
        </Typography>
        <div style={{ padding: 20, textAlign: 'justify' }}>
          <ol type="I">
            <li>
              Que el artículo 1 de la Constitución de la República de El Salvador reconoce a la persona humana como el origen y el fin de la
              actividad del Estado, estableciendo además que, es obligación del Estado asegurar a los habitantes de la República, el goce de
              la libertad, la salud, la cultura, el bienestar económico y la justicia social.
            </li>
            <li>
              Que el artículo 101 inciso 2.º de la Carta Magna prevé que es obligación del Estado promover el desarrollo económico y social
              mediante el incremento de la producción, la productividad y la racional utilización de los recursos.
            </li>
            <li>
              Que el artículo 102 inciso segundo, del mismo cuerpo legal, establece que el Estado fomentará y protegerá la iniciativa
              privada dentro de las condiciones necesarias para acrecentar la riqueza nacional y para asegurar los beneficios de ésta al
              mayor número de habitantes del país.
            </li>
            <li>
              Que el Plan Cuscatlán establece una nueva visión presidencial de modernización y desarrollo en la administración pública en
              todos sus ámbitos, así como la generación de alianzas estratégicas para llevar a cabo la atracción de inversión.
            </li>
            <li>
              Que uno de los principios de la Agenda Digital El Salvador 2020 - 2030 es el bienestar social enfocado en desarrollar una
              mejor calidad de vida para toda la población y futuras generaciones a través de la creación de un Gobierno responsable y
              eficiente, y una ciudadanía empoderada, además del desarrollo económico impulsado por la simplificación e innovación de
              procesos administrativos y productivos, con la utilización de herramientas tecnológicas.
            </li>
            <li>
              Que los ejes de la Agenda Digital El Salvador 2020-2030 promueven la modernización del Estado a través de la
              desmaterialización de documentos físicos que serán reemplazados por documentos electrónicos, conforme a lo establecido en la
              Ley de Firma Electrónica y la Ley de Procedimientos Administrativos; asimismo la adopción de estándares para la normalización
              y digitalización de registros del Órgano Ejecutivo, el intercambio de datos a través de plataformas que permitan la
              interoperabilidad entre los Órganos y demás entidades del Estado y la publicación de datos abiertos y estadísticos
              actualizados, así como también, la modernización de servicios con la aplicación de la Arquitectura de Servicios Digitales de
              Gobierno en sectores estratégicos y la promoción de la transparencia normalizando la generación de conjuntos de datos en
              formatos abiertos para consumo público.
            </li>
            <li>
              Que en virtud de lo expuesto anteriormente; compete al Estado -entre otros- generar las condiciones necesarias para volver más
              eficiente la actividad de la Administración Pública, respecto de los servicios que brinda a la población, atraer inversiones
              extranjeras, que propicien el incremento de la riqueza, así como fomentar la generación de fuentes de empleo para sus
              habitantes, pudiendo para tal fin realizar alianzas estratégicas que fomenten y privilegien la confianza en el país y que
              permita su desarrollo, incluyendo entre ello la transformación digital de sus entidades gubernamentales.
            </li>
            <li>
              Que en virtud de lo señalado en el considerando anterior, el Gobierno y Estado de El Salvador, por medio del Órgano Ejecutivo,
              suscribió un convenio de Alianza Estratégica con Google LLC, con la finalidad de impulsar la transformación digital dentro de
              la República, centrándose en la eficiencia de costos y en la mejora de los servicios que brinda la administración pública,
              aprovechando los servicios y tecnología que brinda dicha compañía.
            </li>
            <li>
              Que en dicho convenio se estableció entre otros puntos la posibilidad de que el Órgano Ejecutivo presente a la Asamblea
              Legislativa los proyectos de ley que sean necesarios para generar las condiciones para la implementación y/o ejecución del
              proyecto.
            </li>
          </ol>
          <Typography>
            <strong> POR TANTO,</strong>
          </Typography>
          <br />
          <Typography>
            En uso de sus facultades constitucionales y a iniciativa del Presidente de la República, por medio de la Ministra de Relaciones
            Exteriores y de la Ministra de Economía.
          </Typography>
          <br />
          <Typography>
            <strong>DECRETA</strong> la siguiente:
          </Typography>
          <br />
          <br />
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography align="center" variant="h2" component="h3">
                LEY GENERAL PARA LA MODERNIZACIÓN DIGITAL DEL ESTADO
              </Typography>
              <br />
              <Typography align="center" variant="h4">
                CAPÍTULO I{' '}
              </Typography>
              <Typography align="center" variant="h4">
                OBJETO
              </Typography>
            </Grid>
          </Grid>
          <br />
          <Typography>
            <strong>Objeto</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 1.</strong>- La presente ley tiene por objeto establecer las disposiciones necesarias para la implementación,
            desarrollo, transformación digital y modernización del Estado Salvadoreño reconociendo de manera general y obligatoria, los
            compromisos internacionales que el Estado adquiera para tal fin, con entidades de derecho público o privado, y en particular los
            derivados de la Alianza Estratégica suscrita entre el Gobierno de la República de El Salvador, y Google LLC; así como los
            distintos compromisos, contratos, acuerdos o instrumentos, bilaterales, interinstitucionales o multilaterales que deriven de
            esta y que promuevan la inversión extranjera y otorguen beneficios sociales y/o económicos para la República de El Salvador.
          </Typography>
          <br />
          <Typography>
            <strong>Definiciones</strong>
          </Typography>
          <br />
          <div style={{ marginLeft: 10 }}>
            <Typography>
              <strong>Art. 2.-</strong> Para efectos de esta Ley, se entenderá lo siguiente:
            </Typography>
            <ol type="I">
              <li>
                <strong>“Entidades del Estado”:</strong> las señaladas en el artículo 3, segundo inciso, de la presente Ley.
              </li>
              <li>
                <strong>“Autoridad Firmante de la Alianza”:</strong> Dependencia del Órgano Ejecutivo que haya suscrito un acuerdo,
                convenio, carta de entendimiento o cualquier otro documento de carácter obligacional en nombre del Estado y Gobierno de El
                Salvador.
              </li>
              <li>
                <strong>“Servicios”:</strong> a los bienes y servicios, incluyendo el desarrollo de infraestructura, que ofrezca el Socio
                Estratégico.
              </li>
              <li>
                <strong>“Socio Estratégico”:</strong> Google LLC, o cualquiera de sus afiliadas, subsidiarias, sucursales, u personas
                jurídicas controladas por -o bajo el control al que está sujeta la misma, sus sucesores o cesionarios respecto de la Alianza
                Estratégica, incluyendo sin limitar los compromisos, contratos, acuerdos o instrumentos por los que se implemente la misma.
              </li>
            </ol>
          </div>
          <br />
          <Typography>
            <strong>Implementación</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 3.-</strong> Facúltese al Órgano ejecutivo, dentro del ámbito de sus competencias, en representación del Gobierno
            de la República de El Salvador, a negociar y suscribir los compromisos, contratos, acuerdos o instrumentos que sean necesarios
            para crear e implementar las Alianzas Estratégicas, necesarias para la modernización digital del Estado, así como negociar y
            suscribir adendas o modificaciones a las mismas; todo sin perjuicio de las ratificaciones Legislativas que fueren necesarias de
            conformidad con la naturaleza de cada uno de los instrumentos a suscribir.
          </Typography>
          <br />
          <Typography>
            Asimismo, quedan facultadas, dentro del ámbito de sus competencias y de conformidad con la ley, todas las instituciones del
            Estado, sus dependencias y organismos auxiliares; los Órganos Ejecutivo, Legislativo y Judicial; las instituciones oficiales
            autónomas, así como las empresas estatales, inclusive la Comisión Ejecutiva Hidroeléctrica del Río Lempa, el Instituto
            Salvadoreño del Seguro Social y las municipalidades, a emitir los actos administrativos y suscribir Acuerdos de Afiliación y
            cualquier otro tipo de contratos o acuerdo con el Socio Estratégico a fin de implementar la Alianza.
          </Typography>
          <br />
          <br />
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography align="center" variant="h4">
                CAPÍTULO II{' '}
              </Typography>
              <Typography align="center" variant="h4">
                ASIGNACIÓN PRESUPUESTARIA
              </Typography>
            </Grid>
          </Grid>
          <br />
          <Typography>
            <strong>Presupuesto</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 4.-</strong> Todas las Entidades del Estado estarán autorizadas para establecer las asignaciones presupuestarias
            respecto de los servicios que deseen adquirir, conforme a lo establecido en la Alianza Estratégica y sus necesidades.
          </Typography>
          <br />
          <Typography>
            Las asignaciones presupuestarias a que se refiere el primer inciso de este artículo corresponderán a cada uno de los ejercicios
            presupuestarios, de acuerdo con los años por los que esté vigente la Alianza Estratégica.
          </Typography>
          <br />
          <Typography>
            No obstante lo establecido en el inciso inmediato anterior de este artículo, las Entidades del Estado podrán tener presupuesto
            para asignaciones relacionadas con la Alianza Estratégica para ejercicios posteriores a los antes señalados, dependiendo de las
            necesidades que tengan de alguno o algunos de los servicios, así como de las negociaciones contractuales que el Órgano
            Ejecutivo, a nombre del Gobierno de la República, lleve a cabo con el mencionado Socio Estratégico.
          </Typography>
          <br />
          <Typography>
            Las entidades del Estado estarán facultadas para utilizar los servicios ofrecidos por el Socio Estratégico, aún después de los
            ejercicios presupuestarios referidos en el inciso primero de este artículo, con base en los compromisos, contratos, acuerdos o
            instrumentos entre el Socio Estratégico y el Ministerio.
          </Typography>
          <br />
          <Typography>
            En todo caso, se garantizará que la totalidad de las asignaciones presupuestarias de las entidades del Estado que suscriban
            Acuerdos de Afiliación individualizados o cualquier otro tipo de compromisos, contratos, acuerdos o instrumentos con el Socio
            Estratégico, vinculados con esta Alianza Estratégica, entre todas, puedan ser de al menos{' '}
            <strong>QUINIENTOS MILLONES DE DOLARES DE LOS ESTADOS UNIDOS DE AMERICA (USD$500,000,000.00)</strong> , en total, durante los
            ejercicios fiscales establecidos en el inciso segundo de este artículo.
          </Typography>
          <br />
          <Typography>
            El Ministerio de Hacienda tendrá la obligación de asegurar la disponibilidad presupuestaria cada año para que las entidades del
            Estado puedan ejercer el presupuesto para obtener servicios por parte del Socio Estratégico, en los términos establecidos en el
            presente artículo, pudiendo emitir normatividad necesaria para ese fin y en particular realizando los ajustes que sean
            necesarios en las políticas y lineamientos de formulación presupuestaria, con el fin que cada institución pueda afrontar los
            compromisos para el cumplimiento de la Alianza Estratégica.
          </Typography>
          <br />
          <Typography>
            <strong>Ejecución Presupuestal</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 5.- </strong>Las Entidades del Estado, como ejecutores de sus propios presupuestos, serán responsables, de la
            utilización racional, eficiente y transparente de los recursos asignados para el desarrollo, transformación digital y
            modernización de todo el Estado, en virtud de la Alianza Estratégica, los cuales deberán destinarse para el objeto de esta ley y
            dicha Alianza.
          </Typography>
          <br />
          <Typography>
            Asimismo, cada una de las Entidades del Estado determinará, con base en sus necesidades que cada una de ellas tenga con el fin
            de cumplir mejor sus objetivos y atribuciones legales, si le es conveniente recibir alguno de los servicios que ofrece el Socio
            Estratégico y en coordinación con la administración y el gobierno de la Alianza Estratégica que se determine para este fin.
          </Typography>
          <br />
          <Typography>
            Las oficinas de Auditoría Interna de cada entidad del Estado, velarán por el cumplimiento de las Normas Técnicas de Control
            Interno.
          </Typography>
          <br />
          <br />
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography align="center" variant="h4">
                CAPÍTULO III{' '}
              </Typography>
              <Typography align="center" variant="h4">
                EJECUCIÓN DE LA ALIANZA
              </Typography>
            </Grid>
          </Grid>
          <br />
          <Typography>
            <strong>Gobierno de la Alianza Estratégica</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 6.-</strong> El Gobierno de la República de El Salvador, representado en los términos de este artículo, estará
            autorizado para participar en la administración y gobierno de la Alianza Estratégica, de conformidad a los contratos, acuerdos o
            cualesquier otros documentos que celebren para tales efectos, derivados de la Alianza Estratégica.
          </Typography>
          <br />
          <Typography>
            La representación del Gobierno de la República de El Salvador en los órganos de administración a que se refiere el inciso
            anterior, se realizará por los Ministerios que determine la Autoridad Firmante de la Alianza. A su vez, los Ministros
            correspondientes designarán, de entre sus funcionarios dependientes, a las personas naturales que participarán directamente en
            los mismos.
          </Typography>
          <br />
          <Typography>
            En este sentido, todas las entidades del Estado deberán colaborar y participar en los órganos de administración y gobernanza de
            la Alianza Estratégica, de conformidad a lo establecido en los contratos, acuerdos o instrumentos correspondientes o por
            notificación de la Autoridad Firmante.
          </Typography>
          <br />
          <Typography>
            <strong>Acuerdos de Afiliación Individualizados</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 7.-</strong> Cada entidad del Estado, suscribirá un Acuerdo de Afiliación Individualizado con el Socio Estratégico,
            según se establezca en la Alianza Estratégica y demás convenios, contratos o acuerdos que deriven de esta.
          </Typography>
          <br />
          <Typography>
            Una vez suscrito el acuerdo de afiliación individualizado, cada entidad del Estado, podrá identificar las necesidades de
            adquisición o contratación, elaborando para ello los requerimientos respectivos, los cuales deberán contener las condiciones y
            especificaciones mínimas del objeto a contratar y sus especificaciones técnicas, para ser comunicadas al Socio Estratégico.
          </Typography>
          <br />
          <Typography>
            Las entidades del Estado podrán realizar cuantos requerimientos sean necesarios para la satisfacción de sus necesidades y el
            cumplimiento de sus objetivos institucionales durante la vigencia de la Alianza.
          </Typography>
          <br />
          <Typography>
            <strong>Procedimiento Administrativo</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 8.-</strong> El requerimiento será entregado al representante de cada entidad del Estado, quien remitirá al órgano
            de administración y gobierno de la Alianza Estratégica que se haya constituido para tales efectos. Dicho requerimiento podrá ser
            la exposición de una necesidad o problema que requiera que se presenten ofertas o propuestas de la solución técnica.
          </Typography>
          <br />
          <Typography>
            Una vez recibida la propuesta del Socio Estratégico, la Unidad solicitante, evaluará si los bienes y servicios ofrecidos cumplen
            con el requerimiento.
          </Typography>
          <br />
          <Typography>
            Durante la evaluación la entidad podrá realizar las solicitudes que los acuerdos, convenios y/o contratos le permitan. Si al
            concluir la evaluación, ninguno de los bienes o servicios ofrecidos por el Socio Estratégico cumple con los requeridos, la
            entidad podrá realizar un proceso de contratación pública con base a la legislación correspondiente.
          </Typography>
          <br />
          <Typography>
            En caso de que, luego de la evaluación se determine que los bienes y servicios ofrecidos por el Socio Estratégico, en efecto
            cumplen con el requerimiento, se procederá a solicitar la disponibilidad presupuestaria o financiera a la Unidad Financiera
            Institucional (UFI) o quien haga sus funciones.
          </Typography>
          <br />
          <Typography>
            La Unidad solicitante, remitirá a la Unidad de Compras Públicas (UCP), el requerimiento inicial, la propuesta del Socio
            Estratégico y la disponibilidad presupuestaria o financiera, con lo que abrirá el expediente administrativo correspondiente y
            procederá a elaborar la orden de pedido.
          </Typography>
          <br />
          <Typography>
            La elaboración, suscripción y remisión de la Orden de Pedido, se realizará cumpliendo con las formalidades establecidas en los
            acuerdos, convenios, contratos o lineamientos correspondientes.
          </Typography>
          <br />
          <Typography>
            <strong>Efectos de la orden de Pedido</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 9.-</strong> La orden de pedido es el documento por medio del cual el Socio Estratégico se obliga a la entrega del
            bien y/o servicio conforme a los términos ofrecidos y, a su vez, obliga a la entidad del Estado a realizar el pago
            correspondiente.
          </Typography>
          <br />
          <Typography>
            La orden de pedido será suscrita únicamente por la máxima autoridad o quien esta delegue, previa remisión de la UCP.
          </Typography>
          <br />
          <Typography>
            <strong>Verificación de cumplimiento de órdenes de pedido</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 10.-</strong> La entidad del Estado que emita una orden de pedido designará un supervisor, quien tendrá las
            responsabilidades siguientes:
          </Typography>
          <div style={{ marginLeft: 10 }}>
            <ol type="a">
              <li>verificar el cumplimiento de las cláusulas y/o condiciones de la orden de pedido.</li>
              <li>
                Elaborar oportunamente los informes de avance de la ejecución de entregas de las órdenes de pedido, acorde a lo establecido
                en el requerimiento o a petición de la Unidad solicitante o funcionario competente.
              </li>
              <li>
                Elaborar y suscribir conjuntamente con el Socio Estratégico, las actas de recepción total o parcial de las entregas
                realizadas en virtud de las órdenes de pedido.
              </li>
              <li>
                Informar y remitir a la UCP y al representante de la entidad, copia las actas de recepción y de los informes que hubiesen
                sido elaborados.
              </li>
              <li>
                Cualquier otra responsabilidad que establezca el Gobierno de la Alianza Estratégica, y que le sea encomendado en los
                lineamientos o por la entidad estatal correspondiente.
              </li>
            </ol>
          </div>
          <Typography>
            Las responsabilidades designadas a los supervisores, se considerarán parte de las funciones y atribuciones del cargo que
            desempeñan.
          </Typography>
          <br />
          <Typography>
            <strong>Recepción y liquidación</strong>
          </Typography>
          <br />
          <Typography>
            Art. 11.- El pago de las obligaciones derivadas de las órdenes de pedido deberán ser realizadas según sea acordado en la orden
            de pedido de los bienes o servicios adquiridos.
          </Typography>
          <br />
          <Typography>La recepción de los bienes o servicios adquiridos se hará constar en un acta.</Typography>
          <br />
          <Typography>
            Una vez realizado el pago, la UFI informará al representante y remitirá copia del comprobante a la UCP, quien lo ingresará al
            expediente correspondiente.
          </Typography>
          <br />
          <Typography>
            <strong>Emisión de lineamientos</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 12.-</strong> La Autoridad firmante de la Alianza podrá emitir lineamientos normativos y técnicos, aplicables a las
            Entidades del Estado, siempre que ello sea estrictamente necesario para el debido funcionamiento y la correcta aplicación del
            presente decreto, así como de la Alianza Estratégica y de los contratos, convenios y demás documentos que la implementen.
          </Typography>
          <br />
          <Typography>
            Para la emisión de los lineamientos normativos y técnicos referidos en el inciso inmediato anterior, el Ministerio deberá
            escuchar la opinión del Socio Estratégico y de las Entidades del Estado que participen en el Gobierno de la Alianza Estratégica
            a que se refiere el artículo 6, primer inciso, de esta Ley.
          </Typography>
          <br />
          <Typography>
            <strong>Refuerzo Presupuestario</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 13.-</strong> Para el caso del ejercicio fiscal del año dos mil veintitrés, el Ministerio de Hacienda deberá
            coordinar la realización de las adecuaciones financieras para que de ser necesario, se refuerce el presupuesto de las entidades
            del Estado, de forma que las mismas cuenten con los recursos económicos necesarios para la obtención de Servicios por parte del
            Socio Estratégico, previa ejecución de los compromisos, contratos, acuerdos o instrumentos que correspondan en términos de la
            Alianza Estratégica.
          </Typography>
          <br />
          <Typography>
            <strong>Especialidad</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 14.-</strong> La presente ley es de carácter especial; por consiguiente, sus normas prevalecerán sobre la Ley
            Orgánica de la Administración Financiera del Estado y cualquier otra que la contrarié, quedando excluida la presente ley, de la
            aplicación de la Ley de Compras Públicas.
          </Typography>
          <br />
          <Typography>
            En este sentido, el Ministerio y las instituciones que formen parte de los órganos, grupos, y/o comités referidos en la presente
            ley, estarán facultados para contratar asesores legales, financieros, o técnicos de cualquier naturaleza, nacionales o
            extranjeros, que sean necesarios para crear, implementar y ejecutar la Alianza Estratégica. Para este fin la Autoridad Firmante
            de la Alianza deberá establecer lineamientos específicos para su cumplimiento.
          </Typography>
          <br />
          <Typography>
            Salvo por razones de conveniencia técnica y económica debidamente motivada, cada entidad del Estado, podrá iniciar un
            procedimiento de contratación pública de los bienes y servicios objeto de la Alianza Estratégica, sin la previa aplicación del
            procedimiento administrativo establecido en el artículo 8 de la presente ley, para los cuales le serán aplicables la Ley de
            Compras Públicas y la Ley Orgánica de la Administración Financiera del Estado.
          </Typography>
          <br />
          <Typography>
            <strong>Solución de Controversias</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 15.-</strong> Se reconocerán los mecanismos que el Socio Estratégico y el Órgano Ejecutivo acuerden mutuamente para
            resolver las controversias derivadas de, o relativas a la Alianza Estratégica y de los contratos, convenios y demás documentos
            que la implementen.
          </Typography>
          <br />
          <Typography>
            <strong>Vigencia de esta Ley</strong>
          </Typography>
          <br />
          <Typography>
            <strong>Art. 16.-</strong> El presente decreto entrará en vigencia ocho días después de su publicación en el Diario Oficial.
          </Typography>
          <br />
          <Typography>
            DADO EN EL SALÓN AZUL DEL PALACIO LEGISLATIVO. San Salvador, a los cinco días del mes de septiembre del año dos mil veintitrés.
          </Typography>

          <br />
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <br />
              <Typography align="center">ERNESTO ALFREDO CASTRO ALDANA,</Typography>
              <Typography align="center">PRESIDENTE.</Typography>
            </Grid>

            <Grid container>
              <Grid item xs={6}>
                <br />
                <Typography align="center">SUECY BEVERLEY CALLEJAS ESTRADA,</Typography>
                <Typography align="center">PRIMERA VICEPRESIDENTA.</Typography>
              </Grid>
              <Grid item xs={6}>
                <br />
                <Typography align="center">RODRIGO JAVIER AYALA CLAROS,</Typography>
                <Typography align="center">SEGUNDO VICEPRESIDENTE.</Typography>
              </Grid>
            </Grid>
          </Grid>
          <br />
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography align="center">GUILLERMO ANTONIO GALLEGOS NAVARRETE,</Typography>
              <Typography align="center">TERCER VICEPRESIDENTE.</Typography>
            </Grid>

            <Grid container>
              <Grid item xs={6}>
                <br />
                <Typography align="center">ELISA MARCELA ROSALES RAMÍREZ,</Typography>
                <Typography align="center">PRIMERA SECRETARIA.</Typography>
              </Grid>
              <Grid item xs={6}>
                <br />
                <Typography align="center">NUMAN POMPILIO SALGADO GARCÍA,</Typography>
                <Typography align="center">SEGUNDO SECRETARIO.</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <br />
                <Typography align="center">REYNALDO ANTONIO LÓPEZ CARDOZA,</Typography>
                <Typography align="center">TERCER SECRETARIO.</Typography>
              </Grid>
              <Grid item xs={6}>
                <br />
                <Typography align="center">REINALDO ALCIDES CARBALLO CARBALLO,</Typography>
                <Typography align="center">CUARTO SECRETARIO.</Typography>
              </Grid>
            </Grid>
          </Grid>
          <br />
          <br />
          <Typography>CASA PRESIDENCIAL: San Salvador, a los seis días del mes de septiembre de dos mil veintitrés.</Typography>
          <br />
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography>PUBLÍQUESE,</Typography>
              <br />
              <br />
              <Typography align="center">NAYIB ARMANDO BUKELE ORTEZ,</Typography>
              <Typography align="center">Presidente de la República.</Typography>
            </Grid>

            <Grid item xs={12}>
              <br />
              <Typography align="center">JUANA ALEXANDRA HILL TINOCO,</Typography>
              <Typography align="center">Ministra de Relaciones Exteriores.</Typography>
            </Grid>

            <Grid item xs={12}>
              <br />
              <Typography align="center">MARÍA LUISA HAYEM BREVÉ,</Typography>
              <Typography align="center">Ministra de Economía.</Typography>
            </Grid>
          </Grid>
        </div>

        <br />
        <Typography>D. O. N° 166</Typography>
        <Typography>Tomo N° 440</Typography>
        <Typography>Fecha: 7 de septiembre de 2023</Typography>

        <br />
        <Typography>NGC/adar</Typography>
        <Typography>29B09-2023</Typography>
      </div>
    </>
  );
};
